import { zodResolver } from '@hookform/resolvers/zod';
import { referralSchema, type Referral } from '@pgs/shared';
import { useForm } from 'react-hook-form';
import { focusFirstError } from '../focusFirstError';
import { NavButtons } from '../NavButtons';
import { StepPanel } from '../StepPanel';
import { RadioGroup } from '@/components/form/RadioGroup';
import { TextField } from '@/components/form/TextField';

interface Props {
  defaultValues?: { hasCode?: 'yes' | 'no'; code?: string };
  onBack: () => void;
  onSubmit: (values: Referral) => void;
}

type FormShape = { hasCode: 'yes' | 'no'; code?: string };

export const Step1Referral = ({ defaultValues, onBack, onSubmit }: Props) => {
  const form = useForm<FormShape>({
    resolver: zodResolver(referralSchema),
    defaultValues: {
      hasCode: defaultValues?.hasCode,
      code: defaultValues?.code,
    } as FormShape,
    mode: 'onBlur',
  });
  const {
    register,
    control,
    watch,
    handleSubmit,
    formState: { errors },
  } = form;

  const hasCode = watch('hasCode');

  return (
    <StepPanel
      icon="fa-users"
      title="Refer A Friend Code"
      description={
        <>
          If you have been sent or given a code from a friend, use it here — it will generate 1000
          bonus MyWallet points when you first get paid!
          <br />
          <br />
          You can create your own code once you are a live contractor with People Group Services.
        </>
      }
    >
      <form
        onSubmit={handleSubmit((values) => onSubmit(values as Referral), focusFirstError)}
        className="flex flex-col justify-center"
      >
        <RadioGroup
          control={control}
          name="hasCode"
          label="Do you have a referral code?"
          layout="stacked"
          options={[
            { value: 'yes', label: 'I have a code — enter it here' },
            { value: 'no', label: "I don't have a code" },
          ]}
        />
        {hasCode === 'yes' && (
          <TextField
            containerClassName="mt-3"
            label="Referral Code"
            placeholder="1DFfg45rTH6"
            {...register('code')}
            error={(errors as { code?: { message?: string } }).code?.message}
          />
        )}
        <NavButtons onBack={onBack} submit />
      </form>
    </StepPanel>
  );
};
